import { Component, OnInit, Input } from "@angular/core";
import { FirebaseService } from "src/app/core";
import { MDBModalRef, MDBModalService } from "ng-uikit-pro-standard";
import { AddCityFormComponent } from "../../forms/add-city-form/add-city-form.component";
import { AddVenueFormComponent } from "../../forms/add-venue-form/add-venue-form.component";

@Component({
  selector: "ll-page-header",
  templateUrl: "./page-header.component.html",
  styleUrls: ["./page-header.component.scss"]
})
export class PageHeaderComponent implements OnInit {
  modalRef: MDBModalRef;

  constructor(
    private fb: FirebaseService,
    private modalService: MDBModalService
  ) {}
  @Input() title: string;
  @Input() subtitle: string;
  @Input() button: string;
  ngOnInit() {}
  openCity() {
    this.modalRef = this.modalService.show(AddCityFormComponent, {
      ignoreBackdropClick: true,
      class: "modal-dialog-centered",
      containerClass: "",
      animated: true
    });
  }
  openVenue() {
    this.modalRef = this.modalService.show(AddVenueFormComponent, {
      ignoreBackdropClick: false,
      class: "modal-dialog-centered",
      animated: true
    });
  }
}
